/**
 * @author       denys.yefremov@gmail.com (Denys Yefremov)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  Function to randomize number based on the input string
 * @param {(string|number)} input - any string or number, which would be taken to calculate output number
 * @param {number} limit - max number after randomization
 * @returns {number} random number or random item from the provided list
 */
export const getDeterministicRandomNumber = (
  input: string | number,
  limit: number = 4
): number => {
  const inputAsString = typeof input === 'string' ? input : input.toString()
  let sum = 0

  for (const char of inputAsString) {
    sum += char.charCodeAt(0)
  }

  return sum % limit
}
